export class ContactReferent {
    static jsonMap = {
        id: { key: 'id', optional: true },
        nom: { key: 'nom', optional: true, default: '' },
        prenom: { key: 'prenom', optional: true, default: '' },
        mail: { key: 'mail', optional: true, default: '' },
        telephone: { key: 'telephone', optional: true, default: '' }
    };

    public id: number;
    public nom: string;
    public prenom: string;
    public mail: string;
    public telephone: string;
}
